import { z } from 'zod';

import { ApplicantStatus, FeeStatus, Gender } from '../enums.js';
import { emailValidationSchema } from './auth.js';

export const ApplicantDashboardRowSchema = z.object({
  agent: z.null(),
  applicationId: z.string(),
  applicationStatus: z.nativeEnum(ApplicantStatus),
  courseId: z.string(),
  dob: z.string(),
  email: z.string().and(emailValidationSchema),
  familyName: z.string(),
  feeStatus: z.nativeEnum(FeeStatus),
  gender: z.nativeEnum(Gender),
  givenName: z.string(),
  hasAgent: z.null(),
  intakeId: z.string(),
  intendedLevelOfStudy: z.string(),
  isExistingStudent: z.boolean(),
  nationality: z.string(),
  pKey: z.string(),
  phoneNumber: z.string(),
  ucasId: z.string(),
  uni: z.string(),
  userId: z.string(),
});

/* eslint-disable-next-line @typescript-eslint/no-empty-object-type */
export interface IApplicantRow extends z.infer<typeof ApplicantDashboardRowSchema> {}
